import { connect } from 'react-redux'
import { compose } from 'recompose'
import { selectTotalEquity } from '../../../store/selectors/home/equity'
import { withCashOutProps } from '../../../features/homeowners/composables/withMinimumEquityAndGemDisplayProps'
import ifRefiEligible from '../../../features/homeowners/composables/ifRefiEligible'
import { EquityPanel } from '../../../constants/notificationRefs'
import gems from './gems'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'

const defaultDM = { question: CUSTOMER_MESSAGES.USING_EQUITY.message, topic: CUSTOMER_MESSAGES.USING_EQUITY.topic }

const CashOutContainer = compose(
  withCashOutProps({
    gems,
    defaultDM,
    cardRef: EquityPanel,
    padding: 50
  }),
  ifRefiEligible,
  connect(state => ({
    equity: selectTotalEquity(state)
  }))
)

export default CashOutContainer
